import React, { useState, useEffect } from 'react';
import {
  Input,
  Button,
  theme,
  Layout,
  Breadcrumb,
  Row,
  Col,
  Typography,
  Space,
  Form,
  notification,
  Affix,
} from 'antd';
import axios from 'axios';
import GTIN from './GTIN';
import GLN from './GLN';
import Banner from '../assets/images/arbol-gs1.png';
import RadioImageSelector from '../components/RadioImageSelector';
import { SearchOutlined, ArrowRightOutlined } from '@ant-design/icons';

const { Header, Content, Footer } = Layout;
const { Paragraph } = Typography;

//const API_BASE_URL = 'http://verifiedbygs1ec-api.ddns.net';
const API_BASE_URL = 'http://186.66.132.19:3001';
//const API_BASE_URL = 'http://localhost:3001';
// const API_BASE_URL = 'http://localhost:1433';

const Home = () => {
  const [svg, setSvg] = useState('');
  const [captchaToken, setCaptchaToken] = useState('');
  const [type, setType] = useState('gtin');
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [api, contextHolder] = notification.useNotification();
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  useEffect(() => {
    axios.get(`${API_BASE_URL}/api/captcha`).then((res) => {
      setSvg(res.data.svg);
      setCaptchaToken(res.data.token);
    });
  }, []);

  //   const handleSubmit = async () => {
  //     try {
  //       console.log({
  //         baseURL: `http://localhost:1433/api/${type}/${codigo}`,
  //         withCredentials: true,
  //       });

  //       const res = await axios.post(
  //         `http://localhost:1433/api/${type}/${codigo}`,
  //         { captcha },
  //         { withCredentials: true }
  //       );
  //       console.log(res.data);
  //       message.success('Consulta exitosa');
  //       setData(res.data);
  //     } catch (err) {
  //       message.error(err.response?.data?.message || 'Error en la consulta');
  //     }
  //   };

  const onFinish = async (_values) => {
    setLoading(true);
    try {
      const res = await axios.post(
        `${API_BASE_URL}/api/${type}/${_values.codigo}`,
        { captcha: _values.captcha, token: captchaToken },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      console.log(res.data);
      api.info({
        message: 'Mensaje de la plataforma:',
        description: 'Consulta exitosa',
        placement: 'topRight',
      });
      setData(res.data);
      setLoading(false);
    } catch (err) {
      console.log(err);
      api.error({
        message: 'Mensaje de la plataforma:',
        description: err.response?.data?.message || 'Error en la consulta',
        placement: 'topRight',
      });
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
    // message(errorInfo);

    const messages = errorInfo.errorFields
      .flatMap((field) => field.errors)
      .map((msg) => <div key={msg}>• {msg}</div>);

    api.error({
      message: 'Revisa los errores en la información ingresada:',
      description: messages,
      placement: 'topRight',
    });
  };

  return (
    <Layout>
      {contextHolder}
      <Header
        style={{
          display: 'flex',
          alignItems: 'center',
          backgroundColor: '#213462',
        }}
      >
        <div
          style={{
            padding: '10px 0px 0px 0px',
            textAlign: 'center',
            width: '100%',
            fontSize: '1.3em',
          }}
        >
          <h3 style={{ color: 'white' }}>
            Verified by GS
            <span style={{ fontSize: '1.20em', fontWeight: '400' }}>1</span>
            <span
              style={{
                fontSize: '1em',
                fontWeight: 400,
                backgroundColor: 'white',
                color: '#213462',
                padding: '8px',
                borderRadius: '8px',
                marginLeft: '10px',
              }}
            >
              Ecuador
            </span>
          </h3>
        </div>
      </Header>
      <Content style={{ padding: '0 48px' }}>
        <Breadcrumb
          style={{ margin: '16px 0' }}
          items={[
            { title: 'GS1 Ecuador' },
            { title: 'Verified by GS1 Ecuador' },
          ]}
        />
        <div
          style={{
            background: colorBgContainer,
            minHeight: 280,
            padding: 24,
            borderRadius: borderRadiusLG,
          }}
        >
          {!data && (
            <Form
              form={form}
              // variant={variant || 'filled'}
              style={{ width: '100%', paddingTop: 24 }}
              // initialValues={{ variant: 'filled' }}
              name="user"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
              // initialValues={{
              //   verify: user.verify === null ? false : user.verify,
              // }}
              // initialValues={{ status: true }}
            >
              <Row>
                <Col
                  xs={24}
                  sm={24}
                  md={10}
                  lg={10}
                  xl={10}
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <img
                    src={Banner}
                    alt="Banner agropecuario"
                    style={{
                      display: 'block', // elimina gaps de inline‐block
                      width: '80%', // ocupa todo el contenedor
                      height: 'auto', // rellena la altura fija
                      objectFit: 'cover', // recorta de forma proporcional
                      //maxWidth: 400,
                    }}
                  />
                </Col>
                <Col xs={24} sm={24} md={14} lg={14} xl={14}>
                  <Paragraph style={{ textAlign: 'justify' }}>
                    Verified es la herramienta que GS1 Ecuador pone a
                    disposición de todos sus afiliados y otros interesados que
                    tengan la necesidad de consultar la empresa o nombre de
                    producto asignado a un código de barras. La búsqueda
                    despliega sólo información registrada en el Ecuador, por lo
                    que si Ud. requiere buscar información de un código asignado
                    en otro país visite www.gs1.org
                  </Paragraph>
                  <Paragraph style={{ textAlign: 'justify' }}>
                    A través de esta herramienta podrá realizar consultas por
                    código de producto (GTIN) y código de localización (GLN)
                  </Paragraph>
                  <RadioImageSelector onSelect={(value) => setType(value)} />

                  <div dangerouslySetInnerHTML={{ __html: svg }} />
                  <Space.Compact size="large" style={{ width: '400px' }}>
                    <Form.Item
                      name="captcha"
                      rules={[
                        {
                          required: true,
                          message: 'ingresa el código de verificación captcha!',
                        },
                      ]}
                      style={{ width: '100%' }}
                    >
                      <Input
                        placeholder="ingresa el código de verificación captcha"
                        //value={captcha}
                        //onChange={(e) => setCaptcha(e.target.value)}
                        style={{ width: '100%' }}
                      />
                    </Form.Item>
                  </Space.Compact>
                  <br />
                  <br />
                  <Space.Compact size="large" style={{ width: '400px' }}>
                    <Form.Item
                      name="codigo"
                      rules={[
                        {
                          required: true,
                          message: 'ingresa el código a buscar!',
                        },
                      ]}
                      style={{ width: '100%' }}
                    >
                      <Input
                        addonBefore={
                          <SearchOutlined style={{ color: '#F26334' }} />
                        }
                        placeholder="ingresa el código a buscar"
                        // value={codigo}
                        // onChange={(e) => setCodigo(e.target.value)}
                      />
                    </Form.Item>

                    <Button
                      type="primary"
                      style={{ backgroundColor: '#213462' }}
                      htmlType="submit"
                      loading={loading}
                      // onClick={handleSubmit}
                    >
                      <ArrowRightOutlined />
                    </Button>
                  </Space.Compact>
                </Col>
              </Row>
            </Form>
          )}

          {data && (
            <Affix offsetTop={100}>
              <div style={{ position: 'fixed', right: 80, zIndex: 999 }}>
                <Button
                  type="primary"
                  onClick={() => {
                    setData(null);
                    form.resetFields();
                    axios.get(`${API_BASE_URL}/api/captcha`).then((res) => {
                      setSvg(res.data.svg);
                      setCaptchaToken(res.data.token);
                    });
                  }}
                  style={{ backgroundColor: '#213462' }}
                >
                  Realizar otra consulta
                </Button>
              </div>
            </Affix>
          )}

          {data && type === 'gtin' ? (
            <GTIN data={data} />
          ) : data && type === 'gln' ? (
            <GLN data={data} />
          ) : null}
        </div>
      </Content>
      <Footer style={{ textAlign: 'center' }}>
        GS1 Ecuador ® {new Date().getFullYear()} Todos los derechos reservados
      </Footer>
    </Layout>
  );
};

export default Home;
